import HealingOutlinedIcon from '@mui/icons-material/HealingOutlined';

/**
 * Cicatrizes de acne: tipos presentes na pele, mais de um ao mesmo tempo.
 * Referência clínica: classificação de Jacob, Dover e Kaminer (J Am Acad
 * Dermatol, 2001) para as atróficas (ice pick, boxcar, rolling), mais a
 * cicatriz elevada (hipertrófica). Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/acne_scars.php.
 */
const acneScars = {
  key: 'acne_scars',
  name: 'Cicatrizes de acne',
  description: 'Tipos de cicatriz presentes: ice pick, boxcar, rolling e hipertrófica',
  details: 'Registra quais tipos de cicatriz de acne o paciente tem, pelo formato no corte da pele: ice pick (furo estreito e fundo), boxcar (depressão larga de bordas retas), rolling (ondulação suave) e hipertrófica (elevada). Como cada tipo responde a um tratamento diferente, ajuda a montar o plano combinado. Marque todos os tipos presentes; o card mostra os da última consulta e a aba Saúde guarda a evolução.',
  kind: 'multiple',
  icon: HealingOutlinedIcon,
  accent: 'pink',
  options: [
    { value: 'icepick', label: 'Ice pick', caption: 'Estreita e profunda', image: 'acne-cicatrizes-1.png', help: 'Furo estreito, com menos de 2 mm, em forma de V, que desce fundo na derme.' },
    { value: 'boxcar', label: 'Boxcar', caption: 'Bordas retas', image: 'acne-cicatrizes-2.png', help: 'Depressão redonda ou oval, mais larga, com paredes verticais bem marcadas e fundo plano.' },
    { value: 'rolling', label: 'Rolling', caption: 'Ondulada', image: 'acne-cicatrizes-3.png', help: 'Ondulações largas e rasas, de bordas suaves, puxadas por traves fibrosas sob a pele.' },
    { value: 'hypertrophic', label: 'Hipertrófica', caption: 'Elevada', image: 'acne-cicatrizes-4.png', help: 'Cicatriz firme e saliente, acima da superfície da pele, sem passar da área da lesão original.' },
  ],
};

export default acneScars;
